import * as i0 from '@angular/core';
import { inject, Input, ViewEncapsulation, Component, NgModule } from '@angular/core';
import { IS_BROWSER, E11UtilModule } from '@engineering11/ui-lib/e11-ui-utils';
import { CommonModule } from '@angular/common';

class E11InfotipComponent {
    constructor() {
        this.text = '';
        this.size = 'e11-text-base';
        this.link = '';
        this.icon = 'help';
        this.iconSize = 'md-18';
        this.color = 'primary-accent';
        this.isBrowser = inject(IS_BROWSER);
    }
    navigateTo() {
        if (!this.isBrowser)
            return;
        if (this.link) {
            window.location.href = this.link;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11InfotipComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11InfotipComponent, selector: "e11-infotip", inputs: { text: "text", size: "size", link: "link", icon: "icon", iconSize: "iconSize", color: "color" }, ngImport: i0, template: "<span\n  (click)=\"navigateTo()\"\n  [attr.aria-label]=\"text\"\n  [attr.role]=\"'link'\"\n  class=\"e11-infotip e11-cursor-pointer e11-text-skin-primary-accent hover:e11-text-skin-primary {{ size }}\"\n  title=\"{{ text }}\"\n>\n  {{ text }} <span class=\"material-icons-outlined {{ iconSize }}\"> {{ icon }} </span>\n</span>\n", styles: [""], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11InfotipComponent, decorators: [{
            type: Component,
            args: [{ selector: 'e11-infotip', encapsulation: ViewEncapsulation.None, template: "<span\n  (click)=\"navigateTo()\"\n  [attr.aria-label]=\"text\"\n  [attr.role]=\"'link'\"\n  class=\"e11-infotip e11-cursor-pointer e11-text-skin-primary-accent hover:e11-text-skin-primary {{ size }}\"\n  title=\"{{ text }}\"\n>\n  {{ text }} <span class=\"material-icons-outlined {{ iconSize }}\"> {{ icon }} </span>\n</span>\n" }]
        }], ctorParameters: () => [], propDecorators: { text: [{
                type: Input
            }], size: [{
                type: Input
            }], link: [{
                type: Input
            }], icon: [{
                type: Input
            }], iconSize: [{
                type: Input
            }], color: [{
                type: Input
            }] } });

class E11InfotipModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11InfotipModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: E11InfotipModule, declarations: [E11InfotipComponent], imports: [CommonModule, E11UtilModule], exports: [E11InfotipComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11InfotipModule, imports: [CommonModule, E11UtilModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11InfotipModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [E11InfotipComponent],
                    imports: [CommonModule, E11UtilModule],
                    exports: [E11InfotipComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { E11InfotipComponent, E11InfotipModule };
